import { InjectionToken } from '@angular/core';

export const LOG = new InjectionToken<typeof console.log>('padspin.log.log', {
  providedIn: 'root',
  factory: () => console.log.bind(console),
});

export const INFO = new InjectionToken<typeof console.info>(
  'padspin.log.info',
  {
    providedIn: 'root',
    factory: () => console.info.bind(console),
  },
);

export const WARN = new InjectionToken<typeof console.warn>(
  'padspin.log.warn',
  {
    providedIn: 'root',
    factory: () => console.warn.bind(console),
  },
);

export const ERROR = new InjectionToken<typeof console.error>(
  'padspin.log.error',
  {
    providedIn: 'root',
    factory: () => console.error.bind(console),
  },
);

export const DEBUG = new InjectionToken<typeof console.debug>(
  'padspin.log.debug',
  {
    providedIn: 'root',
    factory: () => console.debug.bind(console),
  },
);

export const COUNT = new InjectionToken<typeof console.count>(
  'padspin.log.count',
  {
    providedIn: 'root',
    factory: () => console.count.bind(console),
  },
);

export const TRACE = new InjectionToken<typeof console.trace>(
  'padspin.log.trace',
  {
    providedIn: 'root',
    factory: () => console.trace.bind(console),
  },
);

/** Every logger token, for bulk operations (e.g. mocking). */
export const LOGGER_TOKENS = [
  LOG,
  INFO,
  WARN,
  ERROR,
  DEBUG,
  COUNT,
  TRACE,
] as const;
